<h2>Sponsoren</h2>
<div class="wrapper">
  <a *ngFor="let sponsor of sponsorService.sponsors" [href]="sponsor.link" class="sponsor">
    <image [src]="getImageSrc(sponsor)"></image>
    <h5>{{ sponsor.company }}</h5>
  </a>
</div>
